import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';

export class MeasurementUnit extends Model {

  @Expose()
  code: string;
}
